// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Admin Common Styles — Dark Dashboard Theme ===== */

/* ── Icon Styles ── */
.admin-icon {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.admin-icon--sm {
  width: 16px;
  height: 16px;
}

.admin-icon--xs {
  width: 14px;
  height: 14px;
}

/* ===== Admin Layout ===== */
.admin {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  font-family: var(--admin-font-body);
}

.admin__main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 28px;
  background: var(--admin-bg);
  border-bottom: 1px solid var(--admin-border);
}

.admin__header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin__header-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--admin-text-bright);
}

.admin__header-divider {
  width: 1px;
  height: 24px;
  background: var(--admin-border);
  margin: 0 4px;
}

.admin__header-subtitle {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-top: 2px;
}

.admin__header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin__header-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--admin-border);
  background: var(--admin-surface);
  border-radius: var(--admin-radius-md);
  cursor: pointer;
  color: var(--admin-text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.2s;
}

.admin__header-btn:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-accent);
  color: var(--admin-accent);
}

.admin__header-btn svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.admin__header-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  background: var(--admin-error);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.admin__content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px 28px;
}

/* ===== Admin Sidebar ===== */
.admin-sidebar {
  width: 250px;
  background: #ffffff;
  border-right: 1px solid var(--admin-border);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  transition: width 0.2s;
}

.admin-sidebar--collapsed {
  width: 64px;
  overflow: hidden;
  cursor: pointer;
}

.admin-sidebar--collapsed .admin-sidebar__header {
  padding: 12px 8px;
}

.admin-sidebar--collapsed .admin-sidebar__logo {
  justify-content: center;
  gap: 0;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
}

.admin-sidebar--collapsed .admin-sidebar__nav-section {
  margin-bottom: 8px;
}

.admin-sidebar--collapsed .admin-sidebar__nav {
  padding: 8px;
}

.admin-sidebar--collapsed .admin-sidebar__nav-item {
  justify-content: center;
  padding: 10px;
}

.admin-sidebar--collapsed .admin-sidebar__footer {
  padding: 8px 4px;
}

.admin-sidebar--collapsed .admin-sidebar__user {
  justify-content: center;
  padding: 8px;
}

.admin-sidebar__header {
  padding: 16px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-sidebar__toggle {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--admin-text-muted);
  cursor: pointer;
  border-radius: var(--admin-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

.admin-sidebar__toggle:hover {
  background: var(--admin-surface);
  color: var(--admin-text-primary);
}

/* 접기 아이콘 — Figma 기준 24px (전역 .icon--sm 영향 없이 토글에만 적용) */
.admin-sidebar__toggle .icon {
  width: 24px;
  height: 24px;
}

.admin-sidebar__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.admin-sidebar__logo-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #a78bfa, #6366f1);
  border-radius: var(--admin-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.admin-sidebar__logo-text {
  font-size: 14px;
  font-weight: 700;
  color: var(--admin-text-bright);
}

.admin-sidebar__logo-badge {
  background: var(--admin-accent);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: var(--admin-radius-sm);
}

.admin-role-selector {
  margin-bottom: 16px;
}

.admin-role-selector__button {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--admin-accent-bg);
  border: 1px solid rgba(167, 139, 250, 0.2);
  border-radius: var(--admin-radius-md);
  cursor: pointer;
  text-align: left;
}

.admin-role-selector__icon {
  width: 36px;
  height: 36px;
  background: var(--admin-accent);
  border-radius: var(--admin-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.admin-role-selector__info {
  flex: 1 1;
}

.admin-role-selector__name {
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
}

.admin-role-selector__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
}

.admin-role-selector__status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: var(--admin-accent);
}

.admin-role-selector__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--admin-success);
}

.admin-sidebar__nav {
  padding: 8px 12px;
  flex: 1 1;
  overflow-y: auto;
}

.admin-sidebar__nav-section {
  margin-bottom: 20px;
}

.admin-sidebar__nav-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 12px;
}

.admin-sidebar__nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--admin-radius-md);
  color: var(--admin-text-secondary);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 2px;
  transition: all 0.2s;
  border-left: 2px solid transparent;
}

.admin-sidebar__nav-item:hover {
  background: var(--admin-surface);
  color: var(--admin-text-primary);
}

.admin-sidebar__nav-item--active {
  background: var(--admin-accent-bg);
  color: var(--admin-accent);
  border-left: 2px solid var(--admin-accent);
}

.admin-sidebar__nav-badge {
  margin-left: auto;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--admin-accent-bg);
  color: var(--admin-accent);
  font-size: 11px;
  font-weight: 600;
  border-radius: 9999px;
  padding: 0 6px;
}

.admin-sidebar__footer {
  border-top: 1px solid var(--admin-border);
  padding: 8px;
}

.admin-sidebar__user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--admin-radius-md);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-sidebar__user:hover {
  background: var(--admin-surface);
}

.admin-sidebar__user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
}

.admin-sidebar__user-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-sidebar__user-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 600;
  color: var(--admin-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-sidebar__user-email {
  font-size: 11px;
  color: var(--admin-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

img.admin-sidebar__user-avatar,
img.admin-sidebar__user-dropdown__avatar {
  object-fit: cover;
  background: transparent;
}

.admin-sidebar__user-chevron {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: var(--admin-text-muted);
}

/* ── Sidebar User Dropdown ── */
.admin-sidebar__user-dropdown {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-lg);
  box-shadow: var(--admin-shadow-dropdown);
  overflow: hidden;
  animation: adminMenuSlideUp 0.15s ease;
}

@keyframes adminMenuSlideUp {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

.admin-sidebar__user-dropdown__profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}

.admin-sidebar__user-dropdown__avatar {
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.admin-sidebar__user-dropdown__info {
  flex: 1 1;
  min-width: 0;
}

.admin-sidebar__user-dropdown__name {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-bright);
}

.admin-sidebar__user-dropdown__email {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-top: 2px;
}

.admin-sidebar__user-dropdown__role {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa;
  font-size: 10px;
  font-weight: 600;
  border-radius: 9999px;
  letter-spacing: 0.3px;
}

.admin-sidebar__user-dropdown__divider {
  height: 1px;
  background: var(--admin-border);
  margin: 0;
}

.admin-sidebar__user-dropdown__item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  text-decoration: none;
}

.admin-sidebar__user-dropdown__item:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-sidebar__user-dropdown__item .icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.admin-sidebar__user-dropdown__item--danger {
  color: var(--admin-error);
}

.admin-sidebar__user-dropdown__item--danger:hover {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

/* ===== Admin Cards ===== */
.admin-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-lg);
  overflow: hidden;
}

.admin-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-card__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-bright);
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-card__actions {
  display: flex;
  gap: 8px;
}

.admin-card__body {
  padding: 20px;
}

/* ===== Admin Buttons ===== */
.admin-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: var(--admin-radius-md);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-btn--primary {
  background: var(--admin-accent);
  color: #fff;
}

.admin-btn--primary:hover {
  background: var(--admin-accent-hover);
}

.admin-btn--secondary {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-secondary);
}

.admin-btn--secondary:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-muted);
}

.admin-btn--success {
  background: var(--admin-success);
  color: #fff;
}

.admin-btn--success:hover {
  filter: brightness(1.1);
}

.admin-btn--danger {
  background: var(--admin-error);
  color: #fff;
}

.admin-btn--danger:hover {
  filter: brightness(1.1);
}

.admin-btn--ghost {
  background: transparent;
  color: var(--admin-text-secondary);
}

.admin-btn--ghost:hover {
  background: var(--admin-surface);
  color: var(--admin-text-primary);
}

.admin-btn--sm {
  padding: 6px 12px;
  font-size: 12px;
}

.admin-btn--xs {
  padding: 4px 8px;
  font-size: 11px;
}

.admin-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Admin Badges ===== */
.admin-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-badge--success {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-badge--warning {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-badge--error {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-badge--info {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-badge--inactive {
  background: rgba(71, 85, 105, 0.2);
  color: var(--admin-text-muted);
}

/* ===== Admin Modal ===== */
.admin-modal-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.admin-modal-overlay.active {
  display: flex;
}

.admin-modal {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-xl);
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: var(--admin-shadow-modal);
}

.admin-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-bright);
}

.admin-modal-close {
  width: 32px;
  height: 32px;
  border-radius: var(--admin-radius-md);
  background: var(--admin-bg);
  border: none;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-modal-close:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-modal-body {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(90vh - 140px);
}

.admin-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--admin-border);
}

/* ===== Admin Form Elements ===== */
.admin-form-group {
  margin-bottom: 20px;
}

.admin-form-group:last-child {
  margin-bottom: 0;
}

.admin-form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--admin-text-primary);
}

.admin-form-label span {
  font-weight: 400;
  color: var(--admin-text-muted);
}

.admin-form-input,
.admin-form-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md);
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
}

.admin-form-input:focus,
.admin-form-select:focus {
  outline: none;
  border-color: var(--admin-accent);
  box-shadow: 0 0 0 3px var(--admin-accent-bg);
}

.admin-form-input::placeholder {
  color: var(--admin-text-dim);
}

.admin-form-hint {
  font-size: 11px;
  color: var(--admin-text-muted);
  margin-top: 6px;
}

.admin-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.admin-form-input--readonly {
  background: var(--admin-surface);
  color: var(--admin-text-secondary);
  cursor: default;
}

/* ===== Admin Search Input ===== */
.admin-search {
  position: relative;
}

.admin-search__input {
  width: 100%;
  padding: 10px 14px 10px 40px;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-md);
  font-size: 12px;
  background: var(--admin-surface);
  color: var(--admin-text-primary);
  transition: all 0.2s;
}

.admin-search__input:focus {
  outline: none;
  border-color: var(--admin-accent);
}

.admin-search__input::placeholder {
  color: var(--admin-text-dim);
}

.admin-search__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--admin-text-muted);
}

/* ===== Admin Tabs ===== */
.admin-tabs {
  display: flex;
  gap: 4px;
  background: var(--admin-surface);
  border-radius: 10px;
  padding: 3px;
  overflow-x: auto;
}

.admin-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-muted);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.admin-tab:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-secondary);
}

.admin-tab--active {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-tab__count {
  background: var(--admin-surface-hover);
  color: var(--admin-text-secondary);
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
}

.admin-tab--active .admin-tab__count {
  background: var(--admin-accent-bg);
  color: var(--admin-accent);
}

/* ===== Admin Table ===== */
.admin-table-wrap {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-lg);
  overflow-x: auto;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-table th {
  text-align: left;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  white-space: nowrap;
}

.admin-table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--admin-border-light);
  vertical-align: middle;
  color: var(--admin-text-secondary);
  font-size: 13px;
}

.admin-table tbody tr {
  transition: background 0.15s;
  cursor: pointer;
}

.admin-table tbody tr:hover {
  background: rgba(167, 139, 250, 0.04);
}

.admin-table tbody tr:last-child td {
  border-bottom: none;
}

/* ===== Admin Pagination ===== */
.admin-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.admin-pagination__info {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-pagination__right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-pagination__size {
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-pagination__size-label {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-pagination__size-select {
  padding: 4px 8px;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-sm);
  background: var(--admin-bg);
  color: var(--admin-text-secondary);
  font-size: 12px;
}

.admin-pagination__size-select:focus {
  outline: none;
  border-color: var(--admin-accent);
}

.admin-pg__nav {
  display: flex;
  align-items: center;
  gap: 4px;
}

.admin-pg__btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-sm);
  background: transparent;
  color: var(--admin-text-secondary);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-pg__btn:hover:not(:disabled) {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-muted);
  color: var(--admin-text-primary);
}

.admin-pg__btn--a {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
  border-color: var(--admin-accent);
}

.admin-pg__btn--a:hover {
  background: var(--admin-accent-bg);
  color: var(--admin-accent);
}

.admin-pg__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ===== Admin Toggle ===== */
.admin-toggle {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}

.admin-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.admin-toggle__slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: var(--admin-surface-hover);
  border-radius: 9999px;
  transition: 0.3s;
}

.admin-toggle__slider:before {
  content: '';
  position: absolute;
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  transition: 0.3s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.admin-toggle input:checked + .admin-toggle__slider {
  background: var(--admin-accent);
}

.admin-toggle input:checked + .admin-toggle__slider:before {
  transform: translateX(18px);
}

/* ===== Admin Status Dot ===== */
.admin-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.admin-status-dot--success {
  background: var(--admin-success);
  box-shadow: 0 0 0 3px var(--admin-success-bg), 0 0 8px rgba(74, 222, 128, 0.3);
}

.admin-status-dot--warning {
  background: var(--admin-warning);
  box-shadow: 0 0 0 3px var(--admin-warning-bg), 0 0 8px rgba(251, 146, 60, 0.3);
}

.admin-status-dot--error {
  background: var(--admin-error);
  box-shadow: 0 0 0 3px var(--admin-error-bg), 0 0 8px rgba(248, 113, 113, 0.3);
}

.admin-status-dot--inactive {
  background: var(--admin-text-dim);
}

/* ===== Admin Toast ===== */
.admin-toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  padding: 14px 20px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  color: var(--admin-text-primary);
  border-radius: var(--admin-radius-md);
  font-size: 13px;
  font-weight: 500;
  z-index: 9999;
  animation: toastIn 0.3s ease;
  box-shadow: var(--admin-shadow-dropdown);
}

@keyframes toastIn {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.admin-toast--success {
  border-left: 3px solid var(--admin-success);
}

.admin-toast--warning {
  border-left: 3px solid var(--admin-warning);
}

.admin-toast--error {
  border-left: 3px solid var(--admin-error);
}

/* ===== Admin Notification Dropdown ===== */
.admin-notification-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 360px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--admin-radius-lg);
  box-shadow: var(--admin-shadow-dropdown);
  z-index: 100;
  display: none;
}

.admin-notification-dropdown--open {
  display: block;
}

.admin-notification-dropdown__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-notification-dropdown__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--admin-text-bright);
}

.admin-notification-dropdown__action {
  font-size: 12px;
  color: var(--admin-accent);
  cursor: pointer;
}

.admin-notification-dropdown__action:hover {
  color: var(--admin-accent-hover);
}

.admin-notification-dropdown__list {
  max-height: 320px;
  overflow-y: auto;
}

.admin-notification-dropdown__footer {
  padding: 10px 16px;
  border-top: 1px solid var(--admin-border);
  text-align: center;
}

.admin-notification-dropdown__footer a {
  font-size: 12px;
  color: var(--admin-accent);
  text-decoration: none;
}

.admin-notification-dropdown__footer a:hover {
  color: var(--admin-accent-hover);
}
`, "",{"version":3,"sources":["webpack://./src/css/AdminCommon.css"],"names":[],"mappings":"AAAA,2DAA2D;;AAE3D,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,wCAAwC;EACxC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,gCAAgC;EAChC,8EAA8E;AAChF;;AAEA;EACE,8BAA8B;EAC9B,6EAA6E;AAC/E;;AAEA;EACE,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;EACrC,wCAAwC;EACxC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* ===== Admin Common Styles — Dark Dashboard Theme ===== */\n\n/* ── Icon Styles ── */\n.admin-icon {\n  width: 20px;\n  height: 20px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.admin-icon--sm {\n  width: 16px;\n  height: 16px;\n}\n\n.admin-icon--xs {\n  width: 14px;\n  height: 14px;\n}\n\n/* ===== Admin Layout ===== */\n.admin {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  font-family: var(--admin-font-body);\n}\n\n.admin__main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 28px;\n  background: var(--admin-bg);\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin__header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin__header-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n}\n\n.admin__header-divider {\n  width: 1px;\n  height: 24px;\n  background: var(--admin-border);\n  margin: 0 4px;\n}\n\n.admin__header-subtitle {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n}\n\n.admin__header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin__header-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  border-radius: var(--admin-radius-md);\n  cursor: pointer;\n  color: var(--admin-text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  transition: all 0.2s;\n}\n\n.admin__header-btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-accent);\n  color: var(--admin-accent);\n}\n\n.admin__header-btn svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.admin__header-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  min-width: 18px;\n  height: 18px;\n  background: var(--admin-error);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 9999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n}\n\n.admin__content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 28px;\n}\n\n/* ===== Admin Sidebar ===== */\n.admin-sidebar {\n  width: 250px;\n  background: #ffffff;\n  border-right: 1px solid var(--admin-border);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  transition: width 0.2s;\n}\n\n.admin-sidebar--collapsed {\n  width: 64px;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__header {\n  padding: 12px 8px;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__logo {\n  justify-content: center;\n  gap: 0;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__nav-section {\n  margin-bottom: 8px;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__nav {\n  padding: 8px;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__nav-item {\n  justify-content: center;\n  padding: 10px;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__footer {\n  padding: 8px 4px;\n}\n\n.admin-sidebar--collapsed .admin-sidebar__user {\n  justify-content: center;\n  padding: 8px;\n}\n\n.admin-sidebar__header {\n  padding: 16px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-sidebar__toggle {\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: var(--admin-text-muted);\n  cursor: pointer;\n  border-radius: var(--admin-radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n}\n\n.admin-sidebar__toggle:hover {\n  background: var(--admin-surface);\n  color: var(--admin-text-primary);\n}\n\n/* 접기 아이콘 — Figma 기준 24px (전역 .icon--sm 영향 없이 토글에만 적용) */\n.admin-sidebar__toggle .icon {\n  width: 24px;\n  height: 24px;\n}\n\n.admin-sidebar__logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.admin-sidebar__logo-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #a78bfa, #6366f1);\n  border-radius: var(--admin-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.admin-sidebar__logo-text {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n}\n\n.admin-sidebar__logo-badge {\n  background: var(--admin-accent);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: var(--admin-radius-sm);\n}\n\n.admin-role-selector {\n  margin-bottom: 16px;\n}\n\n.admin-role-selector__button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--admin-accent-bg);\n  border: 1px solid rgba(167, 139, 250, 0.2);\n  border-radius: var(--admin-radius-md);\n  cursor: pointer;\n  text-align: left;\n}\n\n.admin-role-selector__icon {\n  width: 36px;\n  height: 36px;\n  background: var(--admin-accent);\n  border-radius: var(--admin-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.admin-role-selector__info {\n  flex: 1;\n}\n\n.admin-role-selector__name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n}\n\n.admin-role-selector__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 3px;\n}\n\n.admin-role-selector__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--admin-accent);\n}\n\n.admin-role-selector__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--admin-success);\n}\n\n.admin-sidebar__nav {\n  padding: 8px 12px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.admin-sidebar__nav-section {\n  margin-bottom: 20px;\n}\n\n.admin-sidebar__nav-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 8px 12px;\n}\n\n.admin-sidebar__nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--admin-radius-md);\n  color: var(--admin-text-secondary);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-bottom: 2px;\n  transition: all 0.2s;\n  border-left: 2px solid transparent;\n}\n\n.admin-sidebar__nav-item:hover {\n  background: var(--admin-surface);\n  color: var(--admin-text-primary);\n}\n\n.admin-sidebar__nav-item--active {\n  background: var(--admin-accent-bg);\n  color: var(--admin-accent);\n  border-left: 2px solid var(--admin-accent);\n}\n\n.admin-sidebar__nav-badge {\n  margin-left: auto;\n  min-width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--admin-accent-bg);\n  color: var(--admin-accent);\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 9999px;\n  padding: 0 6px;\n}\n\n.admin-sidebar__footer {\n  border-top: 1px solid var(--admin-border);\n  padding: 8px;\n}\n\n.admin-sidebar__user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: var(--admin-radius-md);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-sidebar__user:hover {\n  background: var(--admin-surface);\n}\n\n.admin-sidebar__user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 9999px;\n  background: linear-gradient(135deg, #a78bfa, #7c3aed);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.admin-sidebar__user-meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.admin-sidebar__user-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--admin-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-sidebar__user-email {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nimg.admin-sidebar__user-avatar,\nimg.admin-sidebar__user-dropdown__avatar {\n  object-fit: cover;\n  background: transparent;\n}\n\n.admin-sidebar__user-chevron {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  color: var(--admin-text-muted);\n}\n\n/* ── Sidebar User Dropdown ── */\n.admin-sidebar__user-dropdown {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-lg);\n  box-shadow: var(--admin-shadow-dropdown);\n  overflow: hidden;\n  animation: adminMenuSlideUp 0.15s ease;\n}\n\n@keyframes adminMenuSlideUp {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.admin-sidebar__user-dropdown__profile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n}\n\n.admin-sidebar__user-dropdown__avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 9999px;\n  background: linear-gradient(135deg, #a78bfa, #7c3aed);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.admin-sidebar__user-dropdown__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-sidebar__user-dropdown__name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n}\n\n.admin-sidebar__user-dropdown__email {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n}\n\n.admin-sidebar__user-dropdown__role {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 2px 8px;\n  background: rgba(167, 139, 250, 0.15);\n  color: #a78bfa;\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 9999px;\n  letter-spacing: 0.3px;\n}\n\n.admin-sidebar__user-dropdown__divider {\n  height: 1px;\n  background: var(--admin-border);\n  margin: 0;\n}\n\n.admin-sidebar__user-dropdown__item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  text-decoration: none;\n}\n\n.admin-sidebar__user-dropdown__item:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-sidebar__user-dropdown__item .icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.admin-sidebar__user-dropdown__item--danger {\n  color: var(--admin-error);\n}\n\n.admin-sidebar__user-dropdown__item--danger:hover {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n/* ===== Admin Cards ===== */\n.admin-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-lg);\n  overflow: hidden;\n}\n\n.admin-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-card__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-card__actions {\n  display: flex;\n  gap: 8px;\n}\n\n.admin-card__body {\n  padding: 20px;\n}\n\n/* ===== Admin Buttons ===== */\n.admin-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: var(--admin-radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-btn--primary {\n  background: var(--admin-accent);\n  color: #fff;\n}\n\n.admin-btn--primary:hover {\n  background: var(--admin-accent-hover);\n}\n\n.admin-btn--secondary {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-secondary);\n}\n\n.admin-btn--secondary:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-muted);\n}\n\n.admin-btn--success {\n  background: var(--admin-success);\n  color: #fff;\n}\n\n.admin-btn--success:hover {\n  filter: brightness(1.1);\n}\n\n.admin-btn--danger {\n  background: var(--admin-error);\n  color: #fff;\n}\n\n.admin-btn--danger:hover {\n  filter: brightness(1.1);\n}\n\n.admin-btn--ghost {\n  background: transparent;\n  color: var(--admin-text-secondary);\n}\n\n.admin-btn--ghost:hover {\n  background: var(--admin-surface);\n  color: var(--admin-text-primary);\n}\n\n.admin-btn--sm {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n.admin-btn--xs {\n  padding: 4px 8px;\n  font-size: 11px;\n}\n\n.admin-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ===== Admin Badges ===== */\n.admin-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-badge--success {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-badge--warning {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-badge--error {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-badge--info {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-badge--inactive {\n  background: rgba(71, 85, 105, 0.2);\n  color: var(--admin-text-muted);\n}\n\n/* ===== Admin Modal ===== */\n.admin-modal-overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n}\n\n.admin-modal-overlay.active {\n  display: flex;\n}\n\n.admin-modal {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-xl);\n  width: 100%;\n  max-width: 520px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: var(--admin-shadow-modal);\n}\n\n.admin-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n}\n\n.admin-modal-close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--admin-radius-md);\n  background: var(--admin-bg);\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-modal-close:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  max-height: calc(90vh - 140px);\n}\n\n.admin-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--admin-border);\n}\n\n/* ===== Admin Form Elements ===== */\n.admin-form-group {\n  margin-bottom: 20px;\n}\n\n.admin-form-group:last-child {\n  margin-bottom: 0;\n}\n\n.admin-form-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--admin-text-primary);\n}\n\n.admin-form-label span {\n  font-weight: 400;\n  color: var(--admin-text-muted);\n}\n\n.admin-form-input,\n.admin-form-select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md);\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n}\n\n.admin-form-input:focus,\n.admin-form-select:focus {\n  outline: none;\n  border-color: var(--admin-accent);\n  box-shadow: 0 0 0 3px var(--admin-accent-bg);\n}\n\n.admin-form-input::placeholder {\n  color: var(--admin-text-dim);\n}\n\n.admin-form-hint {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  margin-top: 6px;\n}\n\n.admin-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.admin-form-input--readonly {\n  background: var(--admin-surface);\n  color: var(--admin-text-secondary);\n  cursor: default;\n}\n\n/* ===== Admin Search Input ===== */\n.admin-search {\n  position: relative;\n}\n\n.admin-search__input {\n  width: 100%;\n  padding: 10px 14px 10px 40px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-md);\n  font-size: 12px;\n  background: var(--admin-surface);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n}\n\n.admin-search__input:focus {\n  outline: none;\n  border-color: var(--admin-accent);\n}\n\n.admin-search__input::placeholder {\n  color: var(--admin-text-dim);\n}\n\n.admin-search__icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--admin-text-muted);\n}\n\n/* ===== Admin Tabs ===== */\n.admin-tabs {\n  display: flex;\n  gap: 4px;\n  background: var(--admin-surface);\n  border-radius: 10px;\n  padding: 3px;\n  overflow-x: auto;\n}\n\n.admin-tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 16px;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-muted);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.admin-tab:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-secondary);\n}\n\n.admin-tab--active {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-tab__count {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-secondary);\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.admin-tab--active .admin-tab__count {\n  background: var(--admin-accent-bg);\n  color: var(--admin-accent);\n}\n\n/* ===== Admin Table ===== */\n.admin-table-wrap {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-lg);\n  overflow-x: auto;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.admin-table th {\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  white-space: nowrap;\n}\n\n.admin-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--admin-border-light);\n  vertical-align: middle;\n  color: var(--admin-text-secondary);\n  font-size: 13px;\n}\n\n.admin-table tbody tr {\n  transition: background 0.15s;\n  cursor: pointer;\n}\n\n.admin-table tbody tr:hover {\n  background: rgba(167, 139, 250, 0.04);\n}\n\n.admin-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ===== Admin Pagination ===== */\n.admin-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n}\n\n.admin-pagination__info {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-pagination__right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-pagination__size {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-pagination__size-label {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-pagination__size-select {\n  padding: 4px 8px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-sm);\n  background: var(--admin-bg);\n  color: var(--admin-text-secondary);\n  font-size: 12px;\n}\n\n.admin-pagination__size-select:focus {\n  outline: none;\n  border-color: var(--admin-accent);\n}\n\n.admin-pg__nav {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.admin-pg__btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-sm);\n  background: transparent;\n  color: var(--admin-text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.admin-pg__btn:hover:not(:disabled) {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-muted);\n  color: var(--admin-text-primary);\n}\n\n.admin-pg__btn--a {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n  border-color: var(--admin-accent);\n}\n\n.admin-pg__btn--a:hover {\n  background: var(--admin-accent-bg);\n  color: var(--admin-accent);\n}\n\n.admin-pg__btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n/* ===== Admin Toggle ===== */\n.admin-toggle {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 22px;\n}\n\n.admin-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.admin-toggle__slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background: var(--admin-surface-hover);\n  border-radius: 9999px;\n  transition: 0.3s;\n}\n\n.admin-toggle__slider:before {\n  content: '';\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background: #fff;\n  border-radius: 50%;\n  transition: 0.3s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.admin-toggle input:checked + .admin-toggle__slider {\n  background: var(--admin-accent);\n}\n\n.admin-toggle input:checked + .admin-toggle__slider:before {\n  transform: translateX(18px);\n}\n\n/* ===== Admin Status Dot ===== */\n.admin-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.admin-status-dot--success {\n  background: var(--admin-success);\n  box-shadow: 0 0 0 3px var(--admin-success-bg), 0 0 8px rgba(74, 222, 128, 0.3);\n}\n\n.admin-status-dot--warning {\n  background: var(--admin-warning);\n  box-shadow: 0 0 0 3px var(--admin-warning-bg), 0 0 8px rgba(251, 146, 60, 0.3);\n}\n\n.admin-status-dot--error {\n  background: var(--admin-error);\n  box-shadow: 0 0 0 3px var(--admin-error-bg), 0 0 8px rgba(248, 113, 113, 0.3);\n}\n\n.admin-status-dot--inactive {\n  background: var(--admin-text-dim);\n}\n\n/* ===== Admin Toast ===== */\n.admin-toast {\n  position: fixed;\n  bottom: 24px;\n  right: 24px;\n  padding: 14px 20px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  color: var(--admin-text-primary);\n  border-radius: var(--admin-radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  z-index: 9999;\n  animation: toastIn 0.3s ease;\n  box-shadow: var(--admin-shadow-dropdown);\n}\n\n@keyframes toastIn {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.admin-toast--success {\n  border-left: 3px solid var(--admin-success);\n}\n\n.admin-toast--warning {\n  border-left: 3px solid var(--admin-warning);\n}\n\n.admin-toast--error {\n  border-left: 3px solid var(--admin-error);\n}\n\n/* ===== Admin Notification Dropdown ===== */\n.admin-notification-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 360px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--admin-radius-lg);\n  box-shadow: var(--admin-shadow-dropdown);\n  z-index: 100;\n  display: none;\n}\n\n.admin-notification-dropdown--open {\n  display: block;\n}\n\n.admin-notification-dropdown__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-notification-dropdown__title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n}\n\n.admin-notification-dropdown__action {\n  font-size: 12px;\n  color: var(--admin-accent);\n  cursor: pointer;\n}\n\n.admin-notification-dropdown__action:hover {\n  color: var(--admin-accent-hover);\n}\n\n.admin-notification-dropdown__list {\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.admin-notification-dropdown__footer {\n  padding: 10px 16px;\n  border-top: 1px solid var(--admin-border);\n  text-align: center;\n}\n\n.admin-notification-dropdown__footer a {\n  font-size: 12px;\n  color: var(--admin-accent);\n  text-decoration: none;\n}\n\n.admin-notification-dropdown__footer a:hover {\n  color: var(--admin-accent-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
